export default __webpack_public_path__ + "static/media/@book.86e25cc9.svg";